export const LEFT_COLUMN = [
  "reprodukovana_hudba",
];

export const RIGHT_COLUMN = [
  "doprava_1km",
  "manipulace_rakvi_nositky",
  "manipulace_rakvi_pat",
  "nosic_osoba_hod",
  "rizeni_pohrebu",
  "chlazeni_24h",
  "mrazeni_24h",
  "alternativni_misto_organizace",
  "asistence_alternativni_rozlouceni_hod",
  "autobus_sm_hosti",
  "cekaci_doba_dpp_nosic_osoba",
  "cekaci_doba_zapocata_hod",
  "chladici_zarizeni_den",
  "civilni_recnik_ke_hrobu",
  "civilni_recnik_mimo_ck",
  "civilni_recnik_v_sini",
  "dechova_hudba_od",
  "dezinfekce_vozu",
  "doklady_odvoz_cizince",
  "foto_zesnuleho",
  "holeni",
  "hra_na_varhany",
  "hra_varhany_s_dechovou",
  "katafalk_obradni_sin",
  "konani_pohrebu_so_ne",
  "konani_pohrebu_svatky",
  "krajka",
  "kremace",
  "krizky",
  "kvetinova_vyzdoba",
  "kytice",
  "letovani_vlozky",
  "liceni_malovani_nehtu",
  "likvidace_kvetinove_vyzdoby",
  "likvidace_zinkove_vlozky",
  "manipulace_telo_abn_rakev",
  "manipulace_urnou",
  "mrazici_zarizeni_den",
  "nositka",
  "obleceni",
  "obleceni_infekcni",
  "obleceni_rubase",
  "obrad_s_urnou_zapujceni_rakve",
  "obrad_s_urnou_zapujceni_urny",
  "obradnik_mimo_ck",
  "obradnik_v_sini_pouze_pri_hudbe",
  "odsyp_popela",
  "online_prenos",
  "otevreni_a_zalepeni_urny",
  "poduska",
  "pojizdny_katafalk",
  "prani_objednavatele",
  "prevoz_ck_pausal",
  "prevoz_jednoho_tela_cb_krematorium",
  "prevoz_tela_cb_krematorium_pausal",
  "priprava_prezentace_do30",
  "priprava_prezentace_nad30",
  "privezeni_urny_cb",
  "promitani_fotografii",
  "pronajem_chladici_komora",
  "pronajem_drevenych_zidli_kus",
  "pronajem_kaple",
  "pronajem_obradni_sin",
  "pronajem_varhan",
  "provize",
  "pruvod",
  "pruvod_10min_hrbitov",
  "pruvod_10min_vozem",
  "rakev",
  "reprodukovana_hudba_mimo_sin",
  "rezijni_naklady",
  "rezijni_naklady_bez_obradu",
  "rozptyl",
  "rubas",
  "sjednani_obradu",
  "sjednani_obradu_online",
  "sjednani_zpopelneni_bez_obradu",
  "souprava",
  "stejnokroj_osoba",
  "stuhy",
  "svice",
  "telefony_telegramy",
  "transportni_nositka_vc_desinfekce",
  "transportni_rakev_vc_desinfekce",
  "ukony_zamestnancu",
  "ulozeni",
  "ulozeni_urny_mesic",
  "umrtni_oznameni",
  "umyvani",
  "umyvani_obleceni_ulozeni_ustrojeni",
  "uprava_tela_socialni_pohreb",
  "uredni_urna",
  "ustrojeni",
  "vak",
  "vence",
  "vlozka_zinek",
  "vystaveni_bez_obradu_vystavni_mistnost_katafalk",
  "vystaveni_fotografie",
  "vystaveni_kvetinove_vyzdoby_1ks",
  "vystaveni_kytice_ks",
  "vystaveni_vence_ks",
  "vystaveni_zesnuleho",
  "vystaveni_zesnuleho_covid",
  "zajisteni_prevozu_mimo_uredni_hodiny",
  "zapujceni_lucerny",
  "zapujceni_stojanu",
  "zaznam_z_obradu",
  "zpev",
];


export const SLUZBY_SECTIONS = {
  kremace: [
    {
      key: "sjednani",
      title: "Sjednání a administrativa",
      ids: [
        "sjednani_obradu",
        "sjednani_obradu_online",
        "administrativa",
        "kremace",
        "tiskparte",
        "umrtni_oznameni",
        "kondolencni_kniha"
      ],
    },
    {
      key: "prevoz",
      title: "Převoz, chlazení a manipulace",
      ids: [
        "doprava_1km",
        "prevoz_pausal_ck",
        "prevoz_krematorium_cb",
        "chlazeni_24h",
        "mrazeni_24h",
        "manipulace_rakvi_nositky",
        "manipulace_rakvi_pat",
        "manipulace_telo_abn_rakev",
        "ulozeni"
      ],
    },
    {
      key: "rakev",
      title: "Rakev a úprava zesnulého",
      ids: [
        "rakev",
        "vlozka_zinek",
        "rubas",
        "souprava",
        "poduska",
        "krajka",
        "krizky",
        "obleceni",
        "obleceni_rubase",
        "ustrojeni",
        "umyvani",
        "umyvani_obleceni_ulozeni_ustrojeni",
        "holeni",
        "liceni_malovani_nehtu"
      ],
    },
    {
      key: "obrad",
      title: "Obřad",
      ids: [
        "rizeni_pohrebu",
        "obrad_vlastni",
        "pronajem_obradni_sin",
        "pronajem_kaple",
        "katafalk_obradni_sin",
        "pojizdny_katafalk",
        "reprodukovana_hudba",
        "reprodukovana_hudba_mimo_sin",
        "hra_na_varhany",
        "hra_varhany_s_dechovou",
        "zpev",
        "civilni_recnik_v_sini",
        "civilni_recnik_mimo_ck",
        "obradnik_v_sini_pouze_pri_hudbe",
        "obradnik_mimo_ck"
      ],
    },
    {
      key: "media",
      title: "Foto / video / projekce",
      ids: [
        "fotografie",
        "foto_zesnuleho",
        "video",
        "zaznam_z_obradu",
        "promitani_fotografii",
        "priprava_prezentace_do30",
        "priprava_prezentace_nad30",
        "online_prenos"
      ],
    },
    {
      key: "kvetiny",
      title: "Květiny a výzdoba",
      ids: [
        "kvetiny_vazba",
        "kvetinova_vyzdoba",
        "kytice",
        "vence",
        "stuhy",
        "vystaveni_fotografie",
        "vystaveni_kytice_ks",
        "vystaveni_vence_ks",
        "vystaveni_kvetinove_vyzdoby_1ks"
      ],
    },
    {
      key: "urna",
      title: "Urna a po kremaci",
      ids: [
        "urne_standard",
        "urne_lux",
        "uredni_urna",
        "manipulace_urnou",
        "otevreni_a_zalepeni_urny",
        "odsyp_popela",
        "privezeni_urny_cb"
      ],
    },
  ],

  kremace_bez_obradu: [
    {
      key: "sjednani",
      title: "Sjednání a administrativa",
      ids: [
        "sjednani_zpopelneni_bez_obradu",
        "sjednani_obradu",
        "administrativa",
        "kremace",
        "tiskparte"
      ],
    },
    {
      key: "prevoz",
      title: "Převoz, chlazení a manipulace",
      ids: [
        "doprava_1km",
        "prevoz_pausal_ck",
        "prevoz_krematorium_cb",
        "chlazeni_24h",
        "mrazeni_24h",
        "manipulace_rakvi_nositky",
        "manipulace_rakvi_pat",
        "manipulace_telo_abn_rakev",
        "cekaci_doba_zapocata_hod",
        "ukony_zamestnancu",
        "rezijni_naklady_bez_obradu"
      ],
    },
    {
      key: "rakev",
      title: "Rakev a úprava zesnulého",
      ids: [
        "rakev",
        "vlozka_zinek",
        "rubas",
        "souprava",
        "poduska",
        "krajka",
        "krizky",
        "obleceni",
        "obleceni_rubase",
        "ustrojeni",
        "umyvani",
        "umyvani_obleceni_ulozeni_ustrojeni",
        "holeni",
        "liceni_malovani_nehtu"
      ],
    },
    {
      key: "urna",
      title: "Urna a po kremaci",
      ids: [
        "urne_standard",
        "urne_lux",
        "uredni_urna",
        "manipulace_urnou",
        "otevreni_a_zalepeni_urny",
        "odsyp_popela",
        "privezeni_urny_cb"
      ],
    },
  ],

  pohreb: [
    {
      key: "sjednani",
      title: "Sjednání a administrativa",
      ids: [
        "sjednani_obradu",
        "administrativa",
        "tiskparte",
        "umrtni_oznameni",
        "kondolencni_kniha"
      ],
    },
    {
      key: "prevoz",
      title: "Převoz, chlazení a manipulace",
      ids: [
        "doprava_1km",
        "prevoz_pausal_ck",
        "chlazeni_24h",
        "mrazeni_24h",
        "manipulace_rakvi_nositky",
        "manipulace_rakvi_pat",
        "manipulace_telo_abn_rakev",
        "ulozeni"
      ],
    },
    {
      key: "rakev",
      title: "Rakev a úprava zesnulého",
      ids: [
        "rakev",
        "vlozka_zinek",
        "rubas",
        "souprava",
        "poduska",
        "krajka",
        "krizky",
        "obleceni",
        "obleceni_rubase",
        "ustrojeni",
        "umyvani",
        "umyvani_obleceni_ulozeni_ustrojeni",
        "holeni",
        "liceni_malovani_nehtu"
      ],
    },
    {
      key: "obrad",
      title: "Obřad",
      ids: [
        "rizeni_pohrebu",
        "obrad_vlastni",
        "pronajem_obradni_sin",
        "pronajem_kaple",
        "katafalk_obradni_sin",
        "pojizdny_katafalk",
        "reprodukovana_hudba",
        "reprodukovana_hudba_mimo_sin",
        "hra_na_varhany",
        "hra_varhany_s_dechovou",
        "zpev",
        "civilni_recnik_v_sini",
        "civilni_recnik_mimo_ck",
        "obradnik_v_sini_pouze_pri_hudbe",
        "obradnik_mimo_ck",
        "civilni_recnik_ke_hrobu"
      ],
    },
    {
      key: "media",
      title: "Foto / video / projekce",
      ids: [
        "fotografie",
        "video",
        "zaznam_z_obradu",
        "promitani_fotografii",
        "priprava_prezentace_do30",
        "priprava_prezentace_nad30",
        "online_prenos",
        "foto_zesnuleho"
      ],
    },
    {
      key: "kvetiny",
      title: "Květiny a výzdoba",
      ids: [
        "kvetiny_vazba",
        "kvetinova_vyzdoba",
        "kytice",
        "vence",
    {
      key: "prevoz",
      title: "Převoz, chlazení a manipulace",
      ids: [
        "doprava_1km",
        "prevoz_pausal_ck",
        "chlazeni_24h",
        "mrazeni_24h",
        "manipulace_rakvi_nositky",
        "manipulace_rakvi_pat",
        "manipulace_telo_abn_rakev",
        "ulozeni"
      ],
    },
    {
      key: "rakev",
      title: "Rakev a úprava zesnulého",
      ids: [
        "rakev",
        "vlozka_zinek",
        "rubas",
        "souprava",
        "poduska",
        "krajka",
        "krizky",
        "obleceni",
        "obleceni_rubase",
        "ustrojeni",
        "umyvani",
        "umyvani_obleceni_ulozeni_ustrojeni",
        "holeni",
        "liceni_malovani_nehtu"
      ],
    },
    {
      key: "obrad",
      title: "Obřad",
      ids: [
        "rizeni_pohrebu",
        "obrad_vlastni",
        "pronajem_obradni_sin",
        "pronajem_kaple",
        "katafalk_obradni_sin",
        "pojizdny_katafalk",
        "reprodukovana_hudba",
        "reprodukovana_hudba_mimo_sin",
        "hra_na_varhany",
        "hra_varhany_s_dechovou",
        "zpev",
        "civilni_recnik_v_sini",
        "civilni_recnik_mimo_ck",
        "obradnik_v_sini_pouze_pri_hudbe",
        "obradnik_mimo_ck",
        "civilni_recnik_ke_hrobu"
      ],
    },
        "civilni_recnik_v_sini",
        "civilni_recnik_mimo_ck",
        "obradnik_v_sini_pouze_pri_hudbe",
        "obradnik_mimo_ck"
      ],
    },
    {
      key: "media",
      title: "Foto / video / projekce",
      ids: [
        "fotografie",
        "foto_zesnuleho",
        "video",
        "zaznam_z_obradu",
        "promitani_fotografii",
        "priprava_prezentace_do30",
        "priprava_prezentace_nad30",
        "online_prenos"
      ],
    },
    {
      key: "kvetiny",
      title: "Květiny a výzdoba",
      ids: [
        "kvetiny_vazba",
        "kvetinova_vyzdoba",
        "kytice",
        "vence",
        "stuhy",
        "vystaveni_fotografie",
        "vystaveni_kytice_ks",
        "vystaveni_vence_ks",
        "vystaveni_kvetinove_vyzdoby_1ks"
      ],
    },
  ],

    prevoz: [
      {
        key: "prevoz",
        title: "Převoz a doprava",
        ids: [
          "doprava_1km",
          "prevoz_pausal_ck",
          "prevoz_krematorium_cb"
        ],
      },
      {
        key: "chlazeni",
        title: "Chlazení a mražení",
        ids: [
          "chlazeni_24h",
          "mrazeni_24h"
        ],
      },
      {
        key: "manipulace",
        title: "Manipulace",
        ids: [
          "manipulace_rakvi_nositky",
          "manipulace_rakvi_pat",
          "manipulace_telo_abn_rakev",
          "administrativa"
        ],
      },
      {
        key: "provozni",
        title: "Provozní položky",
        ids: [
          "cekaci_doba_zapocata_hod",
          "ukony_zamestnancu",
          "rezijni_naklady_bez_obradu",
          "rezijni_naklady"
        ],
      },
    ],

  alternativa: [
    {
      key: "sjednani",
      title: "Sjednání a administrativa",
      ids: [
        "sjednani_obradu",
        "sjednani_obradu_online",
        "administrativa",
        "tiskparte",
        "umrtni_oznameni",
        "kondolencni_kniha"
      ],
    },
    {
      key: "prevoz",
      title: "Převoz, chlazení a manipulace",
      ids: [
        "doprava_1km",
        "prevoz_pausal_ck",
        "chlazeni_24h",
        "mrazeni_24h",
        "manipulace_rakvi_nositky",
        "manipulace_rakvi_pat",
        "manipulace_telo_abn_rakev"
      ],
    },
    {
      key: "rakev",
      title: "Rakev a úprava zesnulého",
      ids: [
        "rakev",
        "vlozka_zinek",
        "rubas",
        "souprava",
        "poduska",
        "krajka",
        "krizky",
        "obleceni",
        "obleceni_rubase",
        "ustrojeni",
        "umyvani",
        "umyvani_obleceni_ulozeni_ustrojeni",
        "holeni",
        "liceni_malovani_nehtu"
      ],
    },
    {
      key: "obrad",
      title: "Alternativní rozloučení",
      ids: [
        "rizeni_pohrebu",
        "alternativni_misto_organizace",
        "asistence_alternativni_rozlouceni_hod",
        "civilni_recnik_mimo_ck",
        "reprodukovana_hudba_mimo_sin"
      ],
    },
    {
      key: "media",
      title: "Foto / video / projekce",
      ids: [
        "fotografie",
        "video",
        "zaznam_z_obradu",
        "promitani_fotografii",
        "priprava_prezentace_do30",
        "priprava_prezentace_nad30",
        "online_prenos"
      ],
    },
    {
      key: "kvetiny",
      title: "Květiny a výzdoba",
      ids: [
        "kvetinova_vyzdoba",
        "kytice",
        "vence",
        "stuhy"
      ],
    },
  ],

  obrad_s_urnou: [
    {
      key: "sjednani",
      title: "Sjednání a administrativa",
      ids: [
        "sjednani_obradu",
        "sjednani_obradu_online",
        "administrativa",
        "tiskparte",
        "umrtni_oznameni",
        "kondolencni_kniha"
      ],
    },
    {
      key: "urna",
      title: "Urna a manipulace",
      ids: [
        "manipulace_urnou",
        "urne_standard",
        "urne_lux",
        "uredni_urna",
        "otevreni_a_zalepeni_urny",
        "odsyp_popela",
        "privezeni_urny_cb"
      ],
    },
    {
      key: "obrad",
      title: "Obřad s urnou",
      ids: [
        "rizeni_pohrebu",
        "obrad_s_urnou_zapujceni_rakve",
        "obrad_s_urnou_zapujceni_urny",
        "pronajem_obradni_sin",
        "pronajem_kaple",
        "katafalk_obradni_sin",
        "pojizdny_katafalk",
        "reprodukovana_hudba",
        "reprodukovana_hudba_mimo_sin",
        "hra_na_varhany",
        "hra_varhany_s_dechovou",
        "zpev",
        "civilni_recnik_v_sini",
        "civilni_recnik_mimo_ck",
        "obradnik_v_sini_pouze_pri_hudbe",
        "obradnik_mimo_ck"
      ],
    },
    {
      key: "media",
      title: "Foto / video / projekce",
      ids: [
        "fotografie",
        "video",
        "zaznam_z_obradu",
        "promitani_fotografii",
        "priprava_prezentace_do30",
        "priprava_prezentace_nad30",
        "online_prenos"
      ],
    },
    {
      key: "kvetiny",
      title: "Květiny a výzdoba",
      ids: [
        "kvetinova_vyzdoba",
        "kytice",
        "vence",
        "stuhy",
        "vystaveni_fotografie",
        "vystaveni_kytice_ks",
        "vystaveni_vence_ks",
        "vystaveni_kvetinove_vyzdoby_1ks"
      ],
    },
  ],

  ostatni: [],
};


export const KREMACE_BEZ_OBRADU_NAVAZUJICI_URNA_SECTIONS = [
  {
    key: "urna_navazujici",
    title: "Navazující obřad s urnou",
    ids: [
      "manipulace_urnou",
      "urne_standard",
      "urne_lux",
      "uredni_urna",
      "otevreni_a_zalepeni_urny",
      "odsyp_popela",
      "privezeni_urny_cb",
      "rizeni_pohrebu",
      "obrad_s_urnou_zapujceni_rakve",
      "obrad_s_urnou_zapujceni_urny",
      "pronajem_obradni_sin",
      "pronajem_kaple",
      "katafalk_obradni_sin",
      "pojizdny_katafalk",
      "reprodukovana_hudba",
      "reprodukovana_hudba_mimo_sin",
      "hra_na_varhany",
      "hra_varhany_s_dechovou",
      "zpev",
      "civilni_recnik_v_sini",
      "civilni_recnik_mimo_ck",
      "obradnik_v_sini_pouze_pri_hudbe",
      "obradnik_mimo_ck",
      "fotografie",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "vystaveni_fotografie",
      "vystaveni_kytice_ks",
      "vystaveni_vence_ks",
      "vystaveni_kvetinove_vyzdoby_1ks",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha"
    ],
  },
];
